<app-step-progress [steps]="steps"></app-step-progress>
<app-page-title [title]="'Order Summary'"></app-page-title>

<div class="row">
    <div class="col-12 col-sm-7 summary">
        <div class="d-none d-sm-block">
            <br />
            <div class="row">
                <div class="col-9 col-sm-9">
                    <strong>Description</strong>
                </div>
                <div class="col-3 col-sm-3">
                    <strong>Price in {{shoppingCartDto?.currencyCode}}</strong>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <hr />
            </div>
        </div>
        <div
            class="row"
            *ngIf='testSessionInformation'
        >
            <div class="col-9 col-sm-9">
                <div [ngClass]="testTypeCssClass">{{testSessionInformation.testTypeDisplayName}} Test</div>

                <div class="block"><strong>{{testDate | customDate: 'selectedTestFormatDateTime'}}</strong>
                    <br *ngIf="testSessionInformation.isWebDelivery" />
                    <span *ngIf="testSessionInformation.isWebDelivery">(Time Zone: {{localTimeZone}})</span>
                </div>

                <div class="block">
                    <strong>{{testSessionInformation.testCentreName}}</strong><br />
                    <ng-container *ngIf="!testSessionInformation.isWebDelivery">
                        <ng-container *ngIf="testSessionInformation.testCentreAddressLine2 && testSessionInformation.testCentreAddressLine2.length > 0">{{testSessionInformation.testCentreAddressLine2}} - </ng-container>{{testSessionInformation.testCentreAddressLine1}}<br />
                        {{testSessionInformation.testCentreCity}}, {{testSessionInformation.testCentreRegion}} <span *ngIf="testSessionInformation.testCentrePostalCode.length > 0">{{testSessionInformation.testCentrePostalCode}}</span><br />
                        {{testCentreCountry}}<br />
                    </ng-container>
                </div>

                <a
                    (click)="redirectTestSelection()"
                    class="link small"
                >Change</a>
            </div>
            <div class="col-3 col-sm-3">
                {{testCost | currency : shoppingCartDto?.currencyCode: ""}}
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <hr />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h6>TEST SCORE RATING PREFERENCE</h6>
            </div>
        </div>
        <div class="row">
            <div class="col-9 col-sm-9">
                <div
                    *ngIf="brandId === BrandEnum.CELPIP"
                    class="block"
                >
                    <strong>Standard rating</strong> - 3-4 business days
                </div>
                <div
                    *ngIf="brandId === BrandEnum.CAEL"
                    class="block"
                >
                    <strong>Standard rating</strong> - 8 business days
                </div>
            </div>
            <div class="col-3 col-sm-3">
                Included
            </div>
        </div>

        <div *ngIf="shoppingCartItemsOnline && shoppingCartItemsOnline.length > 0">
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6>Online Study Material</h6>
                </div>
            </div>
            <div
                class="row my-3"
                *ngFor="let item of shoppingCartItemsOnline"
            >
                <div class="col-9 col-sm-9">
                    <div class="block">
                        <div class="ipp-list">
                            <div class="image">
                                <img [src]="item.imageUrl" />
                            </div>
                            <div class="description">
                                <div class="ipp-title">{{item.productName}}</div>
                                <div
                                    class="ipp-type"
                                    *ngIf="item.productTypeId == 3"
                                >Online e-book (Non printable PDF)</div>
                                <div
                                    class="ipp-type"
                                    *ngIf="item.productTypeId == 8"
                                >Online Product</div>
                                <div
                                    class="ipp-type"
                                    *ngIf="item.productTypeId == 5"
                                >Online Product Bundle</div>
                            </div>
                        </div>
                    </div>
                    <a
                        (click)="removeFromCart(item.id)"
                        class="link small no-underline"
                    ><i class="fa fa-trash-o"></i> Remove</a>
                </div>
                <div class="col-3 col-sm-3">
                    {{item.price | currency : shoppingCartDto?.currencyCode : ""}}
                </div>
                <br />
                <br />
            </div>
        </div>
        <div *ngIf="shoppingCartItemsPaperback && shoppingCartItemsPaperback.length > 0">
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6>Paperback Study Material</h6>
                </div>
            </div>
            <div
                class="row my-3"
                *ngFor="let item of shoppingCartItemsPaperback"
            >
                <div class="col-9 col-sm-9">
                    <div class="block">
                        <div class="ipp-list">
                            <div class="image">
                                <img [src]="item.imageUrl" />
                            </div>
                            <div class="description">
                                <div class="ipp-title">{{item.productName}}</div>
                                <div class="ipp-type">Paperback book</div>
                            </div>
                        </div>
                    </div>
                    <a
                        (click)="removeFromCart(item.id)"
                        class="link small no-underline"
                    ><i class="fa fa-trash-o"></i> Remove</a>
                </div>
                <div class="col-3 col-sm-3">
                    {{item.price | currency : shoppingCartDto?.currencyCode : ""}}
                </div>
            </div>
            <div class="row">
                <div class="col-12"><br /></div>
            </div>
            <div *ngIf="unableToShip">
                <h3>PAPERBACK STUDY MATERIAL SHIPPING</h3>
                <span>Our system could not estimate a shipping option for you at this time. Please change the address or contact our office at {{phoneNumber}} for shipping options.</span>
            </div>
            <div *ngFor="let shippingInfo of shippingInfos">
                <div class="row my-3">
                    <div class="col-9 col-sm-9">
                        <div class="block">
                            <div class="custom-control custom-radio">
                                <input
                                    type="radio"
                                    id="shipping-{{shippingInfo.name}}"
                                    name="shipping"
                                    class="custom-control-input"
                                    [value]="shippingInfo.shippingMethodId"
                                    [(ngModel)]="shippingSelected"
                                />
                                <label
                                    class="custom-control-label"
                                    for="shipping-{{shippingInfo.name}}"
                                    (click)="applyShippingChoice()"
                                ><strong>{{shippingInfo.name}}</strong></label>
                                <div>{{shippingInfo.description}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 col-sm-3">
                        {{shoppingCartDto.currencyCode}} {{shippingInfo.totalFee}}
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="shoppingCartItemsMisc && shoppingCartItemsMisc.length > 0">
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6>Miscellaneous Items</h6>
                </div>
            </div>
            <div
                class="row my-3"
                *ngFor="let item of shoppingCartItemsMisc"
            >
                <div class="col-9 col-sm-9">
                    <div class="block">
                        <div class="ipp-list">
                            <div class="image">
                                <img [src]="item.imageUrl" />
                            </div>
                            <div class="description">
                                <div class="ipp-title">{{item.productName}}</div>
                            </div>
                        </div>
                    </div>
                    <a
                        (click)="removeFromCart(item.id)"
                        class="link small no-underline"
                    ><i class="fa fa-trash-o"></i> Remove</a>
                </div>
                <div class="col-3 col-sm-3">
                    {{item.price | currency : shoppingCartDto?.currencyCode : ""}}
                </div>
                <br />
                <br />
            </div>
        </div>
    </div>
    <br />
    <div
        *ngIf="userAddress && countries"
        class="col-12 col-sm-5"
    >
        <app-address-form
            #shippingAddress
            [submitted]="submitted"
            [address]="userAddress.shippingAddress"
            [heading]="(userAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Shipping Address'"
            [countries]="countries"
            [isOrderSummaryAddress]="true"
            (formValueChanged)="shippingFormValueChanged($event)"
        ></app-address-form>
        <app-address-form
            #billingAddress
            *ngIf="!userAddress.areShippingBillingAddressSame"
            [submitted]="submitted"
            [address]="userAddress.billingAddress"
            [heading]="(userAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Billing Address'"
            [countries]="countries"
            [isOrderSummaryAddress]="true"
            (formValueChanged)="billingFormValueChanged($event)"
        ></app-address-form>

        <div class="form-container compact">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                [(ngModel)]="userAddress.areShippingBillingAddressSame"
                                name="sameAddress"
                                class="custom-control-input"
                                id="same-address-check"
                            />
                            <label
                                class="custom-control-label"
                                for="same-address-check"
                            >Billing address is the same as shipping address</label>
                        </div>
                        <div style="width: 200px; margin:auto; margin-top: 50px;">
                            <button
                                name="saveAddressBtn"
                                type="button"
                                class="btn btn-primary"
                                (click)="updateShippingAddress(userAddress.areShippingBillingAddressSame, userAddress.billingAddress, userAddress.shippingAddress)"
                            >Save Address</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a
                        (click)="toggleDiscountCode()"
                        class="link"
                    >Add a discount code <i
                            class="fa fa-plus"
                            style="font-size: 0.8em; padding-left: 5px;"
                            *ngIf="discountCodeToggle"
                        ></i><i
                            class="fa fa-minus"
                            style="font-size: 0.8em; padding-left: 5px;"
                            *ngIf="!discountCodeToggle"
                        ></i></a>
                </div>
            </div>
            <div
                class="row"
                *ngIf="!discountCodeToggle"
            >
                <div class="col-10">
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Enter discount code"
                            name="discount-code"
                            [(ngModel)]="discountCode"
                        />
                        <div class="input-group-append">
                            <button
                                (click)="applyDiscountCode()"
                                class="btn btn-primary discount-btn"
                            >Apply</button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="box"
                *ngIf="this.shoppingCartDto"
            >
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-8">
                                Subtotal
                            </div>
                            <div class="col-4">
                                {{shoppingCartDto.originalSubTotal - shoppingCartDto.shippingAndHandlingFee | currency : shoppingCartDto.currencyCode : shoppingCartDto.currencyCode + " "}}
                            </div>
                        </div>
                        <div *ngFor="let item of shoppingCartDto.shoppingCartItems">
                            <div
                                *ngIf="item.discountAmount != 0"
                                class="row"
                            >
                                <div class="col-8">
                                    Discount ({{item.discountAmount}}% off {{item.productName}})
                                </div>
                                <div
                                    class="col-4"
                                    style="color:red"
                                >
                                    {{item.price - item.originalPrice | currency : shoppingCartDto.currencyCode : shoppingCartDto.currencyCode + " "}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                Shipping
                            </div>
                            <div class="col-4">
                                {{shoppingCartDto.shippingAndHandlingFee | currency : shoppingCartDto.currencyCode : shoppingCartDto.currencyCode + " "}}
                            </div>
                        </div>
                        <div *ngFor="let tax of shoppingCartDto.taxes">
                            <div class="row">
                                <div class="col-8">
                                    Taxes ({{tax.taxLabel}})
                                </div>
                                <div class="col-4">
                                    {{tax.taxAmount | currency : shoppingCartDto.currencyCode : shoppingCartDto.currencyCode + " "}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <hr />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <strong>Total ({{shoppingCartDto.currencyCode}})</strong>
                            </div>
                            <div class="col-4">
                                <strong>{{shoppingCartDto.total | currency : shoppingCartDto.currencyCode : ""}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="paymentMethods && paymentMethods.length > 1">
    <div class="row">
        <div class="col-md-12">
            <h4>Select a Payment Option</h4>
            <br />
        </div>
    </div>
    <div class="col-md-12">
        <div
            class="form-group"
            style="margin-top: -10px;"
        >
            <div *ngFor="let paymentMethod of paymentMethods">
                <label>
                    <input
                        type="radio"
                        name="radPaymentMethod"
                        value="{{paymentMethod.id}}"
                        [checked]="paymentMethod.id === selectedPaymentMethodId"
                        (click)="selectPaymentMethod(paymentMethod)"
                    >
                    {{paymentMethod.name}} <span *ngIf="paymentMethod.id === 1">(You will be redirected to our payment processor's secure payment page)</span>
                </label>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedPaymentMethodId">
    <div class="row">
        <div class="col-md-12">
            <h4>Payment Option: <strong style="text-decoration: underline;"> {{selectedPaymentMethodName}} </strong></h4>
            <br />
            <p *ngIf="selectedPaymentMethodId === paymentMethodInvoiceId">Please note that you are processing this payment through our invoicing option. You will be invoiced at a later date for the amount owing displayed here. If this is not correct, please let us know at your earliest convenience so we can make the appropriate corrections.</p>
        </div>
    </div>
</div>
<div class="row p-2">
    <div class="col-md-12">
        <div class="form-group">
            <a
                href="{{regPoliciesUrl}}"
                target="_blank"
            >View our transfer, cancellation, and retake policies.</a>
            <br /><br />
            <div *ngIf="selectedPaymentMethodId !== paymentMethodInvoiceId">
                <p *ngIf=" shoppingCartDto?.total > 0 && (!paymentMethods || paymentMethods.length === 0)">You will be redirected to our payment processor's secure payment page.</p>
                <p>To ensure that your browser is compatible with our payment processor<span *ngIf="brandId === BrandEnum.CELPIP"> and learn more about the accepted payment methods</span>, click
                    <span><a
                            target="_blank"
                            href="{{browserRequirementsUrl}}"
                        >here</a>.</span>
                </p>
                <span *ngIf="!paymentInfo">
                    <strong style="color: red; font-size: larger;">We accept VISA ®, Mastercard ®, American Express ®, and payments through PayPal. </strong>
                </span>
                <span *ngIf="paymentInfo">
                    <strong style="color: red; font-size: larger;">{{paymentInfo}} </strong>
                </span>
                <br /><br />
                <form
                    name="order-summary-payment-form"
                    method="post"
                    id="exactForm"
                >
                    <input
                        type="hidden"
                        id="x_login"
                        name="x_login"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_fp_sequence"
                        name="x_fp_sequence"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_fp_timestamp"
                        name="x_fp_timestamp"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_amount"
                        name="x_amount"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_fp_hash"
                        name="x_fp_hash"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_show_form"
                        name="x_show_form"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_currency_code"
                        name="x_currency_code"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_first_name"
                        name="x_first_name"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_last_name"
                        name="x_last_name"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_email"
                        name="x_email"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_invoice_num"
                        name="x_invoice_num"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="x_reference_3"
                        name="x_reference_3"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="userAccountId"
                        name="userAccountId"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="orderNumber"
                        name="orderNumber"
                        value=""
                    />
                </form>
                <form
                    id=ccavenueForm
                    method="post"
                    name="redirect"
                    action=""
                >
                    <input
                        type="hidden"
                        id="encRequest"
                        name="encRequest"
                        value=""
                    />
                    <input
                        type="hidden"
                        id="access_code"
                        name="access_code"
                        value=""
                    />
                </form>
                <form
                    id=paymentechHPPForm
                    name="form1"
                    method="get"
                    action="https://placeholder/hpp/"
                >
                    <input
                        type="hidden"
                        id="uid"
                        name="uid"
                        value=""
                    />
                </form>
            </div>
            <div style="width: 200px; margin:auto; margin-top: 50px;">
                <button
                    name="confirmationYesBtn"
                    type="button"
                    class="btn btn-primary"
                    (click)="placeOrder()"
                    [disabled]="unableToShip || (shoppingCartDto?.shoppingCartItems.length === 0 && shoppingCartDto?.total <= 0) || (paymentMethods?.length > 0 && !selectedPaymentMethodId)"
                >Checkout</button>
            </div>
        </div>
    </div>
</div>
